export default {
  productInfo: {
    AddRow: '添加',
    Save: '保存',
    Ok: '确定',
    Cancel: '取消',
    Search: '查询',
    ProductSelect: '商品选择',
    ProductName: '商品名称',
    ProductType: '商品类别',
    ProductStatus: '商品状态',
    ProductTradeMark: '商品品牌',
    ProductCode: '商品编号',
    ProductAttribute1: '商品属性1',
    ProductAttribute2: '商品属性2',
    StockQuantity: '库存',
    BasePriceValue: '单价',
    GoodsNo: '货号',
    RetailPrice: '零售价',
    Unit: '单位',
    Status: '状态',
    CreateTime: '创建日期',
    ModifyTime: '修改日期',
    UpperShelf: '上架',
    LowerShelf: '下架',
    New_Product: '新品',
    OldProduct: '旧品',
    // 新增
    BasicData: '基本资料',
    BasicInfo: '基本信息',
    Designer: '设计师',
    SeqNo: '排序',
    Label: '标签',
    NewProduct: '新产品',
    Specs: '规格',
    ProductDetails: '商品详情',
    Enclosure: '附件',
    UploadSpecification: '上传规格表',
    UploadInstallPic: '上传安装图片',
    ShieldCustomer: '屏蔽客户',
    CustomerCode: '客户编号',
    CustomerName: '客户名称',
    // 第二个标签页
    PriceSetting: '价格设置',
    UnitType: '单位类型',
    BasicUnit: '基本单位',
    SupUnit: '辅助单位',
    UnitName: '单位名称',
    FirstWholesalePrice: '一级批发价',
    SecondWholesalePrice: '二级批发价',
    ThirdWholesalePrice: '三级批发价',
    FourWholesalePrice: '四级批发价',
    FiveWholesalePrice: '五级批发价',
    AllowWholesalerOrder: '是否允许批发商订货',
    // 第三个标签页
    ProductAttribute: '商品属性',
    UploadPic: '上传图片',
    // 第四个标签页
    ProductPic: '商品图片',
    ListPic: '列表图片',
    Pic1: '详情页图一',
    Pic2: '详情页图二',
    Pic3: '详情页图三',
    Pic4: '详情页图四',
    // 弹出框
    PleaseChooseProductTradeMark: '请选择商品品牌',
    TrademarkCode: '品牌编号',
    TrademarkName: '品牌名称',
    PleaseChooseProductType: '请选择商品分类',
    PleaseChooseProduct: '请选择商品',
    PleaseChooseOneProduct: '请只选择一个商品',
    TypeCode: '分类编号',
    TypeName: '分类名称',
    PleaseChooseDesigner: '请选择设计师',
    DesignerCode: '设计师编号',
    DesignerName: '设计师名称',
    ProductNameCannotBeEmpty: '商品名称不能为空',
    ProductCodeCannotBeEmpty: '商品编号不能为空'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/pmc/productInfo.js